import { render, staticRenderFns } from "./statistic-dashboard.vue?vue&type=template&id=a38e3bc0&"
import script from "./statistic-dashboard.vue?vue&type=script&lang=js&"
export * from "./statistic-dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports